import { Component, HostBinding } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { Router } from '@angular/router';
import { ToggleService } from '../../services/toggle-sidebar.service';
import { ToastrService } from 'ngx-toastr';
import { RedirectService } from '../../services/redirect-service';
import { AuthService } from 'src/app/api/identity/services';

const BASE_CLASSES = 'main-header navbar navbar-expand';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @HostBinding('class') classes: string = BASE_CLASSES;

  public toggle = false;
  public toggleVisible = false;

  constructor(
    private toggleService: ToggleService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService,
    private redirectService: RedirectService
  ) {}

  onToggleMenuSidebar() {
    this.toggle = !this.toggle;
    this.toggleService.updateData(this.toggle);
  }
  logout(): void {
    this.authService.userLogout().subscribe({
      next: response => {
        this.localStorageService.clear();
        this.redirectService.clearRedirectUrl();

        this.router.navigate(['/auth']);
      },
      error: error => {
        this.toastr.error(error?.error?.message);
      },
    });
  }
  toggleVisibleFlag(): void {
    this.toggleVisible = !this.toggleVisible;
  }
}
